import classNames from "classnames";
import * as React from "react";
import { commonClientResx } from "~/resxDist/commonClientResx";
import { useGetColorOfContent } from "~/sharedComponents/colorCoding/useGetColorOfContent";
import { Icon, icon } from "../icons";
import { QTooltipTargetProps } from "../tooltip";
import { Marker } from "../userflow/utils/marker";
import * as styles from "./Chips.less";
export enum ChipsTheme {
    small = "small",
}

type Props = Marker & {
    onSelect?: F<void>;
    onChange?: F<void>;
    minWidth?: string | number;
    classes?: string;
    backgroundColor?: string;
    nonShrinkable?: boolean;
    shrinkable?: boolean;
    theme?: ChipsTheme;
} & QTooltipTargetProps;

export const Chips = React.forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>((props, ref) => {
    const {
        children,
        onSelect,
        onChange,
        minWidth,
        classes,
        backgroundColor,
        nonShrinkable,
        shrinkable,
        theme,
        "data-testid": testId = "",
        ...qtipProps
    } = props;

    const color = useGetColorOfContent(backgroundColor);

    return (
        <div
            className={classNames(
                styles.chips,
                nonShrinkable && styles.non_shrinkable,
                shrinkable && styles.shrinkable,
                styles[theme]
            )}
            style={{ minWidth, backgroundColor, color }}
            data-testid={`chips-${testId}`}
            ref={ref}
            {...qtipProps}
        >
            <div
                className={classNames(styles.chips_text, onSelect && styles.chips_selecting, classes)}
                onClick={onSelect}
            >
                {children}
            </div>
            {onChange && (
                <div className={styles.chips_close} onClick={onChange} title={commonClientResx.Remove} role="button">
                    <Icon iconName={icon.cross} size="small" />
                </div>
            )}
        </div>
    );
});
